// ******* layout settings
export const layoutSidebarLeftWidth = 260
export const layoutSidebarRightWidth = 296
export const layoutMessageTimeout = 3000 // ms
export const layoutMinResolution = {width: 1024, height: 580}

// ******* local/translation settings
export const localLangDefault = "de-DE"
export const localLangList = ["en-GB", "de-DE"]
export const localTranslationMissingPrefix = ""
export const localFormatDecimal = {maximumFractionDigits: 2}
export const localFormatCurrency = {style: 'currency', currency: 'EUR'}
export const localFormatCurrencyShort = {style: 'currency', currency: 'EUR', minimumFractionDigits: 0}
export const localDateOptions = {year: 'numeric', month: '2-digit', day: '2-digit'}
export const localDateTimeOptions = {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}

// ******* room setup settings
export const roomSetupTypeInit = "livingroom"
export const roomSetupShapeInit = "rectangle"
export const roomSetupFireProtectionClassInit = "none"
export const roomSetupShapeDimensionMax = 10000 // max 10000cm for any dimension

// ******* product settings
export const productOptionHideDisablesValues = true
export const productOptionValuesBigSize = [225, 223]
export const productColorOptionIds = [221, 222, 235]
export const productSizeAffectOptionIds = [227] // Form
export const productWireSkus = [
    "duo-ceiling-40",
    "duo-ceiling-48",
    "duo-wall-40",
    "duo-wall-48",
    "uno-ceiling",
    "uno-wall",
]
export const productImagePlaceholder = "/static/version1626421659/frontend/Helgers/aixfoam/de_DE/Magento_Catalog/images/product/placeholder/image.jpg"

// ******* cart settings
export const cartShippingCountryDefault = "DE"
export const cartLangMap = {"de-DE": "de_DE", "en-GB": "en_US"}

// ******* help
export const helpBaseUrl = "/produktfinder/assets/content/help/"

// ******* api
export const getApiHostUrl = () => {
    const host = window.location.host

    if (/dev/.test(host) || /\.lh$/.test(host) || /localhost/.test(host) || /integer-net/.test(host)) {
        return "https://apidev.aixfoam.de/"
    }

    if (/release/.test(host)) {
        return "https://apirelease.aixfoam.de/"
    }

    return "https://api.aixfoam.de/"
}

// ******* solution suggestions
export const progressBar = {
    "averageProcessingDuration": 15000,
    "countProcessingSteps": 60,
    "minimumProcessingTime": 5000
}

export const tip = {
    "viewDuration": 5000
}

export const backgroundImage = {
    "url": "https://source.unsplash.com/random/1280x720/?room,record,sound"
}

export const exitIntent = {
    millisecondsVisitDuration: 20 * 1000, // 20 seconds for quality assurance purpose. Remove after testing and uncomment next line.
    // millisecondsVisitDuration: 6 * 60 * 1000, // 6 minutes
    numberOfImpressionsSelected: 1,
    baseUrl: "/produktfinder/assets/content/exit-intent"
}

export const logoSettings = {
    href: "https://www.aixfoam.de/"
}
